export default __webpack_public_path__ + "static/media/Aegis of the Jackal.9aba755d.jpg";